import moment from 'moment';
import React from 'react';
import { AlertIcon } from './WeekView_2.0';
import { Chip, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { Stack } from '@mui/system';
import { checkIsGracePeriodExpired } from 'src/layouts/components/utils-method';

type Props = {};

const GracePeriodAlert = (props: Props) => {
  const dateOfServiceResponse = useSelector(
    (state: any) => state?.getDateOfServiceReducer?.response?.data
  );

  const getCurrentDay = (eocStartDate: string): number => {
    if (!eocStartDate) return 0;
    const startDate = moment(eocStartDate);
    const currentDate = moment();
    return currentDate.diff(startDate, 'days') + 1; 
  };

  return (
    <Stack
      pl={2}
      gap={1}
      flexDirection="row"
      justifyContent={'start'}
      alignItems={'center'}
      sx={{ height: '44px', background: '#F790091F' }}
    >
      {checkIsGracePeriodExpired(
        dateOfServiceResponse?.eocStartDate,
        dateOfServiceResponse?.gracePeriodDays
      ) ? (
        <>
          <AlertIcon />
          <Typography
            sx={{ color: '#B54708' }}
            variant="subtitle2"
          >
            MDS assessment is required. The grace period has ended — planning is blocked until the assessment is provided
          </Typography>

        </>
      ) : (
        <>
          <AlertIcon />
          <Typography
            sx={{ color: '#B54708' }}
            variant="subtitle2"
            >MDS assessment is required. Planning is temporarily allowed during a {dateOfServiceResponse?.gracePeriodDays}-day grace period  | 
          </Typography>
          <Chip
            label={`Day ${getCurrentDay(dateOfServiceResponse?.eocStartDate)}/${dateOfServiceResponse?.gracePeriodDays}`}
            size="small"
            sx={{ color: '#6366F1', background: '#EBEEFE' }}
          />{' '}
        </>
      )}
    </Stack>
  );
};

export default GracePeriodAlert;
